// Create a single module that includes all modules in this library by
// creating a new require context (see http://webpack.github.io/docs/context.html)
// for finding all module files and then requiring them as dependencies
// to the all-encompassing module.
let requiresModule = require.context('./src', true, /.*[.]module[.]js/);

let moduleNames = [];

let moduleFiles = requiresModule.keys();
_.remove(moduleFiles, function(key) {
  return _.startsWith(key, './extensions');
});

moduleFiles.forEach(function(moduleFile) {
  moduleNames.push(requiresModule(moduleFile));
});

export default angular.module('gazelle', moduleNames)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/index.js